import { deleteReq, postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel } from "@/models/core.model";
import { RunningClubMedia, RunningClubMediaPaginationFilterRequest, UpsertRunningClubMedia } from '@/models/running-club-media.model';

export const getPagedRunningClubMedias = async (input: RunningClubMediaPaginationFilterRequest): Promise<PagedResponseModel<RunningClubMedia>> => {
  return await getReq(createUrl("a/RunningClub/Media/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getRunningClubMedia = async (id: number): Promise<BaseResponseModel<RunningClubMedia>> => {
  return await getReq(createUrl(`a/RunningClub/Media/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertRunningClubMedia = async (input: UpsertRunningClubMedia): Promise<BaseResponseModel<RunningClubMedia>> => {
  return await postReq(createUrl("a/RunningClub/Media/Upsert"),
    input
  ).then((res: any) => res.data);
};

export const deleteRunningClubMedia = async (id: number): Promise<BaseResponseModel<null>> => {
  return await deleteReq(createUrl(`a/RunningClub/Media/Delete/${id}`),
  ).then((res: any) => res.data);
};
